import { apiFetch } from "@core/index";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IUpdatePartnerChannelPayload } from "../utils/types";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";

export const useUpdatePartnerChannel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (config: { payload: IUpdatePartnerChannelPayload }) => {
      const { channelId, payloadData } = config.payload;
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}/${channelId}`, {
        method: "PATCH",
        body: payloadData,
      });
      return response;
    },
    onSuccess: () => {
      enqueueSnackbar("Partner channel updated successfully.", {
        variant: "success",
        autoHideDuration: 2000,
      });
      queryClient.invalidateQueries({ queryKey: ["partnerChannels"] });
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to update partner channel. Error: " + (error ?? ""),
        {
          variant: "error",
          autoHideDuration: 5000,
        },
      );
    },
  });
};
